import React from 'react';

import LoginLayout from '../LoginLayout/LoginLayout';

import LoginHeader from './LoginHeader';
import LoginForm from './LoginForm/LoginForm';

const Login = () =>
  <LoginLayout Header={LoginHeader} Form={LoginForm} />;

export default Login;
